import { useState, useCallback } from "react";
import { putSectionTypesURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const usePutSectionType = (token, onSuccess) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateSectionType = useCallback(
    async (sectionId, styleTypeId) => {
      if (!sectionId || styleTypeId === null || styleTypeId === undefined) {
        setError("Datos inválidos: ID de sección y tipo de estilo requeridos");
        return false;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(putSectionTypesURL(sectionId), {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ styleTypeId }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.message ||
              `Error ${response.status}: ${response.statusText}`,
          );
        }

        const data = await response.json();
        
        if (onSuccess) {
          await onSuccess(data);
        }

        return true;
      } catch (err) {
        const errorMessage =
          err.message || "Error al actualizar el tipo de sección";
        console.error("Error en updateSectionType:", err);
        setError(errorMessage);
        toastAlert(errorMessage, "error");
        return false;
      } finally {
        setLoading(false);
      }
    },
    [token, onSuccess],
  );

  return {
    updateSectionType,
    loading,
    error,
  };
};
